import React, { useContext } from "react";
import { packClasses } from "Utils";
import * as statusColors from "constants/status-colors";
import { ContentContext } from "context/Content";

function VersionStatusField(props) {
    const { state } = useContext(ContentContext);

    if (state.loading || state.performingStateChange) {
        return (
            <div className="flex space-x-2">
                <div className="w-min animate-pulse rounded bg-gray-300 px-2 py-0.5 text-center text-xs font-light capitalize text-gray-300">
                    Draft
                </div>
                <div className="animate-pulse rounded bg-gray-300 px-2 py-0.5 text-center text-xs font-light text-gray-300">
                    Version 0
                </div>
            </div>
        );
    }
    return (
        <div className="flex space-x-2">
            <div
                className={packClasses(
                    statusColors.background[
                        state.content.status ? state.content.status : "default"
                    ],
                    "w-min rounded px-2 py-0.5 text-center text-xs font-light capitalize"
                )}
            >
                {state.content.uuid ? state.content.status : "Draft"}
            </div>
            <div
                className={packClasses(
                    statusColors.background.default,
                    "rounded px-2 py-0.5 text-center text-xs font-light"
                )}
            >
                Version {state.content.uuid ? state.content.version : 1}
            </div>
        </div>
    );
}

export default VersionStatusField;
